var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('h3', {
    staticClass: "title is-4"
  }, [_vm._v("Managing Associations and Certificates")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p'), _c('h4', {
    staticClass: "title is-5"
  }, [_vm._v("Associations")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("The first step in streamlining evidence of insurance requests is to create Associations. To create an Association,\n        choose the\n        "), _c('em', [_vm._v("Create Association")]), _vm._v(" button from the\n        "), _c('router-link', {
    attrs: {
      "to": "/associations"
    }
  }, [_vm._v("Associations")]), _vm._v(" page.\n        "), _c('br'), _vm._v(" "), _c('br')], 1), _vm._m(0), _vm._v(" "), _c('p'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(3), _vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(5), _vm._m(6), _vm._v(" "), _c('p'), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p'), _c('h4', {
    staticClass: "title is-5"
  }, [_vm._v("Direct Link Requests")]), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(10), _vm._m(11), _vm._v(" "), _c('p'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n          Please click the Contact Us link below if you have any questions or need help.\n        ")])])]), _vm._v(" "), _c('Footer')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "900px",
      "min-height": "210px"
    },
    attrs: {
      "src": "/static/img/CreateAssociation.jpg"
    }
  }), _vm._v(" "), _c('figcaption', {
    staticClass: "caption"
  }, [_vm._v("Manage Associations List")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("This will open the Association detail page. On this page you set the Association Name, Pin Number and Status. The\n        "), _c('em', [_vm._v("Pin Number")]), _vm._v(" is used to create a unique URL link for the certificate. See the section below on Direct Link Requests\n        for more information about links to certificates.\n      ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        When the Association\n        "), _c('em', [_vm._v("Status")]), _vm._v(" is set to Draft, the certificate will not be linkable, so make sure to set the Status to Active when\n        you are ready to enable users to access the certificate. Once you have entered the Association Name and Pin Number,\n        you can click the\n        "), _c('em', [_vm._v("Create")]), _vm._v(" button to save the association.")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Now, along the top of the Association page, you will see several buttons. Click the\n        "), _c('em', [_vm._v("Preview")]), _vm._v(" button to generate and download a preview PDF file of the Certificate. Use the\n        "), _c('em', [_vm._v("Link")]), _vm._v(" icon button to get a link to the certificate. This is the link you can send to owners, loan processors\n        and property managers who need to access and generate certificates. Use the\n        "), _c('em', [_vm._v("Copy to Request")]), _vm._v(" button to copy the certificate into a request which you can then customize for a specific\n        person, e.g., by customizing the Certificate Holder.\n        "), _c('br'), _vm._v(" "), _c('br')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "min-height": "175px"
    },
    attrs: {
      "src": "/static/img/AssociationDetailsHeader.jpg"
    }
  }), _vm._v(" "), _c('figcaption', {
    staticClass: "caption"
  }, [_vm._v("Association Header Fields")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          The main section on the Associations page is the Certificate itself. This is a comprehensive form where you can enter details\n          about the insurance policies, expiration dates and coverage that the Association carries. Use the Additional\n          Remarks addendum to provide extra details. You may want to anticipate common questions that a bank normally has\n          and preemptively provide that information. Once you have completed this form, you can set the\n          "), _c('em', [_vm._v("Status")]), _vm._v(" to Active and click the\n          "), _c('em', [_vm._v("Link")]), _vm._v(" button to get the direct link to the certificate. You can paste the link into your browser and try\n          it yourself. When a user requests the Certificate, this form will be generated as a PDF file. Here is an\n          "), _c('a', {
    attrs: {
      "href": "/static/InsuranceCertificate.pdf",
      "target": "_blank"
    }
  }, [_vm._v("example PDF Certificate")]), _vm._v(".\n          "), _c('br'), _vm._v(" "), _c('br')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/CertificateForm.jpg"
    }
  }), _vm._v(" "), _c('figcaption', {
    staticClass: "caption"
  }, [_vm._v("Association Certificate Form")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Now that you have created one of more Associations and their evidence of insurance certificates, users can request copies\n          of those certificates via direct links. Direct links take the form of\n          "), _c('em', [_vm._v("https://www.getcoi.com/certificates/<your agency short name>/<association PIN number>")]), _vm._v(". For an example,\n          try\n          "), _c('a', {
    attrs: {
      "href": "/certificates/arrowig/11111"
    }
  }, [_vm._v("https://www.getcoi.com/certificates/arrowig/11111")]), _vm._v(".\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          When users navigate to a direct link in a web browser, a small request form will be shown. Users can enter 4 pieces of data\n          into this form, which will be populated into the certificate PDF. The\n          "), _c('em', [_vm._v("Property Owner Full Name, Property Address and Loan Number")]), _vm._v(" will be populated into the Additional Remarks\n          addendum of the certificate and the\n          "), _c('em', [_vm._v("Certificate Holder")]), _vm._v(" will be populated into the Certificate Holder field of the certificate. After hitting\n          next, users will be prompted to enter their name and email address, after which, their certificate will be generated\n          and they can download the PDF file.\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "padding-top": "10px"
    },
    attrs: {
      "src": "/static/img/RequestForm.jpg"
    }
  }), _vm._v(" "), _c('figcaption', {
    staticClass: "caption"
  }, [_vm._v("Certificate Request Form")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Certificate requests are recorded by the system and can be viewed, modified and regenerated on the\n          "), _c('a', {
    attrs: {
      "href": "/requests"
    }
  }, [_vm._v("Requests")]), _vm._v(" page.\n          "), _c('br'), _vm._v(" "), _c('br')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/Requests.jpg"
    }
  }), _vm._v(" "), _c('figcaption', {
    staticClass: "caption"
  }, [_vm._v("Requests List")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12ea26eb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Documentation.vue
// module id = 4b0A
// module chunks = 1